import { useState, useRef } from 'react';

// ==================== STATE MANAGEMENT HOOK ====================
export const useChatbotState = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentFlow, setCurrentFlow] = useState('main');
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [paymentData, setPaymentData] = useState({});
  const [completedTransactions, setCompletedTransactions] = useState([]);
  const [checkoutRequestIds, setCheckoutRequestIds] = useState({});
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  return {
    isOpen, setIsOpen,
    messages, setMessages,
    inputText, setInputText,
    isLoading, setIsLoading,
    currentFlow, setCurrentFlow,
    selectedPackage, setSelectedPackage,
    paymentData, setPaymentData,
    completedTransactions, setCompletedTransactions,
    checkoutRequestIds, setCheckoutRequestIds,
    messagesEndRef,
    chatContainerRef
  };
};